import { useState } from "react";
import { useNavigate } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  alpha,
} from "@mui/material";
import ConfirmDialog from "../common/ConfirmDialog";
import fetching from "../../helpers/fetching/fetching";
import fireAlert from "../../helpers/alerts/fireAlert";
import { HiOutlineArrowRightOnRectangle } from "react-icons/hi2";
import {
  removeUserToken,
  removeUserData,
} from "../../redux/features/user/userSlice";
import { UserState } from "../../types/types";

const LogoutButton = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userToken = useSelector((state: UserState) => state.user.userToken);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const logoutUser = async () => {
    setLoading(true);
    try {
      await fetching(`/logout`, userToken, "POST").then((res) => res.json());
    } catch {
      // proceed with local logout even if API fails
    } finally {
      dispatch(removeUserToken());
      dispatch(removeUserData());
      fireAlert("تم تسجيل الخروج بنجاح", "success");
      navigate("/login");
      setLoading(false);
      setOpen(false);
    }
  };

  return (
    <>
      <ListItemButton
        onClick={() => setOpen(true)}
        sx={(theme) => ({
          py: 1.25,
          px: 1.5,
          borderRadius: 2.5,
          color: "text.secondary",
          "&:hover": {
            bgcolor: alpha(theme.palette.error.main, 0.08),
            color: "error.main",
            "& .MuiListItemIcon-root": { color: "error.main" },
          },
        })}
      >
        <ListItemIcon
          sx={{
            minWidth: 40,
            color: "inherit",
            "& svg": { width: 22, height: 22 },
          }}
        >
          <HiOutlineArrowRightOnRectangle />
        </ListItemIcon>
        <ListItemText
          primary="تسجيل الخروج"
          primaryTypographyProps={{ fontSize: "0.875rem", fontWeight: 500 }}
        />
      </ListItemButton>
      <ConfirmDialog
        open={open}
        onClose={() => setOpen(false)}
        onConfirm={logoutUser}
        title="تسجيل خروج"
        confirmLabel="تسجيل الخروج"
        loading={loading}
      >
        <Typography variant="body2">
          هل أنت متأكد أنك تريد تسجيل الخروج؟
        </Typography>
      </ConfirmDialog>
    </>
  );
};

export default LogoutButton;
